import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';

interface IgetInvitationDataTableStructureProps {
  //   store: any;
  createAction?: () => void;
  rowActions?: any;
}

export const getInvitationDataTableStructure = ({ createAction, rowActions }: IgetInvitationDataTableStructureProps): DynamicDataTable => {
  const firstNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.invitation.table.firstName',
    accessorKey: 'prenom',
    variant: DataTableColumnVariant.TEXT,
  };

  const lastNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.invitation.table.lastName',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };

  const emailColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.invitation.table.email',
    accessorKey: 'mail',
    variant: DataTableColumnVariant.TEXT,
  };

  const organismColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.invitation.table.organism',
    accessorKey: 'organisme',
    variant: DataTableColumnVariant.TEXT,
  };

  const functionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.invitation.table.function',
    accessorKey: 'fonction',
    variant: DataTableColumnVariant.TEXT,
  };

  return {
    singular: 'meeting.invitation.singular',
    plural: 'meeting.invitation.plural',
    columns: [lastNameColumn, firstNameColumn, organismColumn, functionColumn, emailColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    createAction,
    rowActions,
    searchableFields: ['prenom', 'nom', 'mail', 'organisme', 'fonction'],
  };
};
